import Vue from 'vue'
import Router from 'vue-router'
import db from '@/services/localstorage'

const LoginView = () => import('@/views/Login')
const HomePage = () => import('@/views/HomePage')
const Register = () => import('@/views/Register')
const RegisterInfo = () => import('@/views/registerInfo/RegisterInfo')
const Retrieve = () => import('@/views/Retrieve')

// const Welcome1View = () => import('@/views/analyze/welcome1')
// const Welcome2View = () => import('@/views/analyze/welcome2')
// const Welcome3View = () => import('@/views/analyze/welcome3')
// const Welcome4View = () => import('@/views/analyze/welcome4')

const RoleUser = () => import('@/views/system/role/RoleUser')

const ParametersSetting = () =>
  import('@/views/basic/agentinfo/parametersetting/ParametersSetting')

const CompanySetting = () =>
  import('@/views/basic/plumberCompany/parametersetting/ParametersSetting')

const plumberCompany = () =>
  import('@/views/basic/plumberCompany/engineerCompany')
const TreeItem = () => import('@/views/system/dicttree/TreeItem')
const DictItem = () => import('@/views/system/dict/DictItem')

const AgentInfo = () => import('@/views/basic/agentinfo/AgentInfo')

const MyAgentEngineerCompany = () =>
  import('@/views/basic/plumberCompany/agencyEngineerCompany')


const MyAgentEngineer = () =>
  import('@/views/engineer/MyAgentEngineer')

const EngineerInfo = () =>
  import('@/views/engineer/engineerInfo')


const InformationMore = () =>
  import('@/components/analyze/InformationMore')

import http from '@/network/http'

Vue.use(Router)

let constRouter = [
  {
    path: '/login',
    name: '登录页',
    component: LoginView
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/home',
    component: HomePage,
    children: [
      {
        path: '/role/roleUser',
        name: '角色用户',
        component: RoleUser
      },
      {
        path: '/tree/treeItem',
        name: '树明细',
        component: TreeItem
      },
      {
        path: '/dict/dictItem',
        name: '字典明细',
        component: DictItem
      },
      {
        path: '/agent/parametersetting',
        name: '代理商参数设置',
        component: ParametersSetting
      },

      {
        path: '/basic/agentinfo',
        name: '代理商详细',
        component: AgentInfo
      },
      {
        path: '/plumberCompany/engineerCompany',
        name: '代理商参数设置',
        component: plumberCompany
      },
      {
        path: '/company/parametersetting',
        name: '水工公司参数设置',
        component: CompanySetting
      },
      {
        path: '/agent/MyAgentEngineerCompany',
        name: '代理商的水工公司',
        component: MyAgentEngineerCompany
      },
      {
        path: '/agent/MyAgentEngineer',
        name: '代理商的所有水工',
        component: MyAgentEngineer
      },
      {
        path: '/notify/InformationMore',
        name: '更多公告',
        component: InformationMore
      }, {
        path: '/engineer/engineerInfo',
        name: '水工公司水工',
        component: EngineerInfo
      }
    ]
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/register/registerinfo',
    name: 'registerinfo',
    component: RegisterInfo
  },
  {
    path: '/retrieve',
    name: 'retrieve',
    component: Retrieve
  }
]

let router = new Router({
  routes: constRouter
})

const whiteList = ['/login', '/register', '/register/registerinfo', '/retrieve']

let asyncRouter

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) !== -1) {
    next()
    return
  }

  let token = db.get('token')
  let user = db.get('user')

  if (!token || !user || !user.userId) {
    // console.log('gotoLogin')
    next('/login')
    return
  }

  if (asyncRouter) {
    next()
    return
  }
  let userId = db.get('userId')
  let userType = db.get('user').userType
  // 获取用户显示的路由菜单

  http
    .get(`permission/getUserRouters/${userId}/${userType}`)
    .then(({ data: res }) => {
      if (res.code == 401) {
        Vue.prototype.$message.error('Token is invalid,please login')
        next('/login')
        return
      }
      asyncRouter = res.data
      save('USER_ROUTER', asyncRouter)

      expandRoutes(asyncRouter)
      routeList.forEach(item => {
        item.children = []
        constRouter[2].children.push(item)
      })
      router.addRoutes(constRouter)

      // console.log(to.path)

      if (to.path == db.get('LAST_URL').path) {
        next({
          path: db.get('LAST_URL').fullPath
        })
      } else {
        next({
          path: to.path
        })
      }
    })
})

function expandRoutes(asyncRouter) {
  asyncRouter.forEach(route => {
    if (route.component) {
      route.component = view(route.component)
      routeList.push(route)
    }

    if (route.children && route.children.length) {
      route.children = expandRoutes(route.children)
    }
  })
}

// 路由菜单列表
var routeList = []

function save(name, data) {
  localStorage.setItem(name, JSON.stringify(data))
}

function view(path) {
  return function(resolve) {
    import(`@/views/${path}.vue`).then(mod => {
      resolve(mod)
    })
  }
}

export default router
